import React from 'react';

import SocialLink from './Social';
import FacebookIcon from '../icons/Facebook';

import classes from '../Footer.scss';

export default function FacebookLink(props) {
  return (
    <SocialLink
      href  = "https://www.facebook.com/cityadsmedia/"
      title = "Facebook"
      {...props}
    >
      <FacebookIcon className={classes.socialIcon} />
    </SocialLink>
  );
}